// biome-ignore lint/suspicious/noConsole: intended console log
export const trace = import.meta.env.DEV ? (...args: any) => console.log('[src/index]', ...args) : () => {};
